import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'

import LanguageTextInput from '@/configuration/components/LanguageTextInput/LanguageTextInput'

import * as Styles from './styles'

const CustomTitle = ({ languages, onChangeCustomTitle, customTitles, onCheckUseCustomTitle, useCustomTitle }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Switch checked={useCustomTitle} onChange={onCheckUseCustomTitle} label={t('Usar nombre personalizado')} />
      {useCustomTitle && (
        <Styles.TranslationContainer>
          <Text type="titleS">{t('Nombre personalizado')}</Text>
          <LanguageTextInput
            languages={languages}
            value={customTitles}
            onChange={onChangeCustomTitle}
            maxLength={128}
          />
        </Styles.TranslationContainer>
      )}
    </Styles.Container>
  )
}

export default CustomTitle
